var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6274 23.9358C35.5692 24.5522 36.6817 26.6432 35.7268 28.4428C34.5664 30.6297 32.9954 32.5789 31.0907 34.1743C28.247 36.5564 24.7822 38.0469 21.1186 38.4643C17.4551 38.8817 13.7512 38.2079 10.4582 36.5251C7.16525 34.8423 4.42555 32.2231 2.57307 28.9868C0.720592 25.7505 -0.164661 22.0369 0.0252201 18.2986C0.215101 14.5604 1.47192 10.9589 3.64246 7.93333C5.81301 4.90772 8.80354 2.58861 12.2495 1.25869C14.5249 0.380562 16.9339 -0.0412578 19.3449 0.00317124C21.4124 0.0412699 22.6992 2.07548 22.2648 4.09717C21.8265 6.13713 19.7802 7.3645 17.7071 7.60086C16.7458 7.71045 15.7969 7.9424 14.8834 8.29496C12.7819 9.10598 10.9583 10.5202 9.6346 12.3653C8.31094 14.2104 7.54451 16.4067 7.42871 18.6863C7.31292 20.966 7.85277 23.2307 8.98246 25.2042C10.1121 27.1778 11.7829 28.775 13.791 29.8013C15.7991 30.8275 18.0579 31.2384 20.292 30.9839C22.5261 30.7293 24.639 29.8204 26.3732 28.3677C27.1494 27.7176 27.8346 26.9712 28.4151 26.1496C29.6051 24.465 31.6615 23.3117 33.6274 23.9358Z",
    fill: "#00D88A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6274 23.9358C35.5692 24.5522 36.6818 26.6433 35.7268 28.4429C34.076 31.5539 31.6029 34.1671 28.5545 35.9678C24.4518 38.3915 19.6042 39.1681 14.9659 38.1447C10.3275 37.1214 6.23437 34.3723 3.49201 30.4385C1.46091 27.525 0.279747 24.1179 0.0438962 20.6037C-0.0935849 18.5553 1.80307 17.1001 3.83966 17.3597C5.86542 17.618 7.24159 19.4971 7.61989 21.5039C7.92844 23.1407 8.57858 24.7064 9.54285 26.0896C11.2152 28.4885 13.7113 30.1649 16.5399 30.789C19.3685 31.413 22.3246 30.9395 24.8266 29.4615C26.2514 28.6198 27.4702 27.487 28.415 26.1496C29.6051 24.465 31.6615 23.3117 33.6274 23.9358Z",
    fill: "#068344"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.815,
    cy: 7.60018,
    r: 4.09231,
    fill: "#00D88A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.50769,
    cy: 21.0461,
    r: 3.50769,
    fill: "#027048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.bc20ff3e80a69babd12352372bc2db3c.svg";
export { ForwardRef as ReactComponent };